// First: Zod's JIT validator off before any schema parses (Safari rejects the
// code it generates). index.html sets the same flag inline; this is the second
// guard, see @ai4nr/tricorder-ui's zod-config.
import '@ai4nr/tricorder-ui/zod-config'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { configurePlatform, initI18n } from '@ai4nr/tricorder-ui'
// Design tokens before the base layers that reference them.
import '@ai4nr/tricorder-ui/tokens.css'
import '@ai4nr/tricorder-ui/base.css'
// The Markdown editor's stylesheet, then its properties set from the tokens.
import '@ai4nr/tricorder-editor/style.css'
import './editor-theme.css'
// The Table view's print sheet (A4), after the themes it overrides.
import './print.css'

import App from './App'
import de from './i18n/de.json'
import en from './i18n/en.json'
import fr from './i18n/fr.json'

configurePlatform({
  appSubdomain: __APP_SUBDOMAIN__,
  apiUrl: import.meta.env.VITE_API_URL,
  dev: import.meta.env.DEV,
  mainDevPort: __MAIN_DEV_PORT__,
  devPortByPrefix: __DEV_PORT_BY_PREFIX__,
})
initI18n({ de, en, fr })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
